import {Component, EventEmitter, Input, NgIterable, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    Aangifte,
    BokkzAlgDataService,
    BokkzIbDataService
} from "@snelstart-ventures/fiscaal/domain-logic";
import {Subscription} from "rxjs";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiLoadingModule} from "@snelstart/ui-loading";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-pga-giften',
    standalone: true,
    imports: [CommonModule, SharedUiAlertModule, SharedUiDetailsModule, SharedUiFormControlsModule, SharedUiLoadingModule, SharedUiButtonModule, SharedUiDialogModule],
    templateUrl: './tekst-pga-giften.component.html',
    styleUrl: './tekst-pga-giften.component.scss',
})
export class TekstPgaGiftenComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();

    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;

    public aangifte = {} as Aangifte;

    public isDefAangifte = {} as boolean;



    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        })
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe(); // Unsubscribe from income tax entity
        }

    }
}
